export enum SESSION_STORAGE_KEYS {
  LT_CONFETTI_FIRED = 'lt_confetti_fired',
  LT_FAMILY_BANNER_MODAL_SHOWN = 'lt_family_banner_modal_shown',
  NAV_HISTORY = 'navHistory',
  STUDENT_DETAILS_INFO = 'student_details_info',
  LT_FAMILY_DISCOUNT_BANNER_SHOWN = 'lt_family_discount_banner_shown'
}
